import { render } from "./SeriesDocumentosPage.vue?vue&type=template&id=3c087d0a&scoped=true"
import script from "./SeriesDocumentosPage.vue?vue&type=script&lang=js"
export * from "./SeriesDocumentosPage.vue?vue&type=script&lang=js"

import "./SeriesDocumentosPage.vue?vue&type=style&index=0&id=3c087d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c087d0a"]])

export default __exports__